export enum IconRotate {
  R90 = '90deg',
  R180 = '180deg',
  R270 = '270deg',
  R360 = '360deg',
}
